import React, { useState } from "react";
import "../AllocationCaseDetails.scss";
import Tabs from "../../../../Reuseable/Tabs/Tabs";
import SmsInteraction from "../../../../components/AllocationComp/SmsInteraction/SmsInteraction";
import WhatsappReaction from "../../../../components/AllocationComp/WhatsappReaction/WhatsappReaction";
import AiCallConversation from "../../../../components/AllocationComp/AiCallConversation/AiCallConversation";
import ManualCallLogs from "../../../../components/AllocationComp/ManualCallLogs/ManualCallLogs";
import { Button } from "antd";
import { ReactComponent as FilterIcon } from "../../../../assets/Icons/filterIcon2.svg";
import { ReactComponent as Dropdown } from "../../../../assets/Icons/dropdown.svg";
import upArrow from "../../../../assets/Icons/UpArrow.svg";
import downArrow from "../../../../assets/Icons/dropdown.svg";
import sentiment from "../../../../assets/Icons/sentiment.svg";
import TableFilterDropdown from "../../../../Reuseable/TableFilter/TableFilter";
import { formatCurrency } from "../../../../assets/helpers";
import { useSelector } from "react-redux";
import AudioPlayer from "../../../../Reuseable/AudioPlayer/AudioPlayer";

const BasicDetails = ({ data }) => {
  const [selectedTab, setSelectedTab] = useState("SMS Interaction");
  const [showTable, setShowTable] = useState(true);
  const { format } = useSelector(state => state.priceFormat);

  const handleArrowClick = () => setShowTable((prev) => !prev);

  const information = [
    { title: "Customer Name", info: data?.customer_name || "NA" },
    { title: "Loan Number", info: data?.loan_no || "NA" },
    { title: "Customer Unique ID", info: data?.customer_id },
    { title: "Contact number", info: data?.cust_mobile_no },
    { title: "Loan Type", info: "NA" },
    { title: "Amount Overdue", info: formatCurrency(data?.amount_overdue, format) },
    { title: "Portfolio", info: data?.bank || 'NA' },
    { title: "CRIF Score", info: 'NA' },
  ];

  const profileData = [
    { title: "Persona Type", info: "High Risk" },
    { title: "Sentiment", info: "Frustrated" },
    { title: "Online Timings", info: "Active 4 PM – 8 PM" },
    {
      title: "Income Source (Derived)",
      info: "Private Job, Low-Income Area (₹20k–30k/Month)",
    },
  ];

  const tabOptions = [
    { label: "SMS Interaction", value: "SMS Interaction" },
    { label: "WhatsApp Interaction", value: "WhatsApp Interaction" },
    { label: "AI Call Conversations", value: "AI Call Conversations" },
    { label: "Manual Call Logs", value: "Manual Call Logs" },
  ];

  return (
    <div className="mainWrapperAllocation">
      <div className="customerLoanInfoContainer">
        <div className="header">
          <h2>Basic Customer & Loan Info</h2>
        </div>
        <div className="InfoContainerBox">
          <div className="detailInfoSect marginBtm">
            {information.slice(0, 4).map((item, index) => (
              <div className="cardOuterBox" key={index}>
                <div className="titleSect_1">
                  <h5 className="header_Text">{item.title}</h5>
                </div>
                <div className="infoSect_1">
                  <p className="info_Text">{item.info}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="detailInfoSect topPadding">
            {information.slice(4, 8).map((item, index) => (
              <div className="cardOuterBox" key={index + 4}>
                <div className="titleSect_1">
                  <h5 className="header_Text">{item.title}</h5>
                </div>
                <div className="infoSect_1">
                  <p className="info_Text">{item.info}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="BehavioralProfileContainer">
        <div className="header">
          <h2>Persona & Behavioral Profile</h2>
        </div>
        <div className="dataContainer">
          {profileData.map((item, index) => (
            <div className="dataWrappedBox" key={index}>
              <div className="titleSect_1">
                <h5 className="header_Text">{item.title}</h5>
              </div>
              <div className="infoSect_1 ">
                <p
                  className={`info_Text ${item.title === "Persona Type" || item.title === "Sentiment"
                    ? "persona_type"
                    : ""
                    }`}
                >
                  {item.title === "Sentiment" && (
                    <img
                      src={sentiment}
                      alt="sentiment"
                      className="sentiment-icon"
                    />
                  )}
                  {item.info}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="interactionSection">
        <div className="interactionWrapper">
          <h2>Interaction</h2>

          <div className="segmentedTabs">
            <Tabs
              options={tabOptions}
              active={selectedTab}
              onChange={setSelectedTab}
              selectorBreakpoint={700}
            />
          </div>
        </div>

        <div className="smsInteractionMainWrapper">
          <div className="smsInteraction">
            <div className="smsTitleSect">
              <h2>{selectedTab}</h2>
            </div>
            <div className="filterTab-wrapper">
              <TableFilterDropdown
                sections={[
                  ...(selectedTab === "SMS Interaction" ||
                    selectedTab === "WhatsApp Interaction" ||
                    selectedTab === "AI Call Conversations" ||
                    selectedTab === "Manual Call Logs"
                    ? [
                      {
                        key: "status",
                        label: "Status",
                        options: [
                          { label: "Not Answered", value: "not_answered" },
                          { label: "Call Picked", value: "call_picked" },
                          { label: "Not Reachable", value: "not_reachable" },
                        ],
                      },
                    ]
                    : []),

                  ...(selectedTab === "AI Call Conversations" ||
                    selectedTab === "Manual Call Logs"
                    ? [
                      {
                        key: "sentiment",
                        label: "Sentiment",
                        options: [
                          { label: "Neutral", value: "neutral" },
                          { label: "Disengaged", value: "disengaged" },
                          { label: "Frustrated", value: "frustrated" },
                          { label: "Cooperative", value: "cooperative" },
                          { label: "Unresponsive", value: "unresponsive" },
                          { label: "Irritated", value: "irritated" },
                          { label: "Avoidant", value: "avoidant" },
                        ],
                      },
                    ]
                    : []),

                  ...(selectedTab === "Manual Call Logs"
                    ? [
                      {
                        key: "disposition",
                        label: "Disposition",
                        min: 20,
                        max: 100,
                      },
                    ]
                    : []),
                ]}
              // onApply={(filters) => console.log("Filters applied", filters)}
              />

              {(selectedTab === "AI Call Conversations" ||
                selectedTab === "Manual Call Logs") && (
                  <div className="arrow" onClick={handleArrowClick}>
                    <img src={showTable ? upArrow : downArrow} alt="arrow" />
                  </div>
                )}
            </div>
          </div>

          <div className="tableForSms">
            {selectedTab === "SMS Interaction" && <SmsInteraction />}
            {selectedTab === "WhatsApp Interaction" && <WhatsappReaction />}

            {showTable && (
              <>
                {selectedTab === "AI Call Conversations" && (
                  <AiCallConversation />
                )}
                {selectedTab === "Manual Call Logs" && <ManualCallLogs caseData={data} />}
                {/* <AudioPlayer
            // src={callData?.recording_file}
            src={'https://collecteaze-dev.s3.ap-south-1.amazonaws.com/collecteaze-dev/media/recordings/2mgru43jz176052367072553619_919588733363_2025-10-15-15-51-27_IBD.mp3'}
            rewindSeconds={5}
            forwardSeconds={5}
            width="100%"
          /> */}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicDetails;
